import { useEffect } from 'react';
export const useType = (debouncePeriod, on, deps = []) => {
    useEffect(() => {
        const re = /^[a-z0-9.-]$/i;
        let text = '';
        let tm;
        const onKey = (e) => {
            if (!e.altKey && !e.shiftKey && !e.metaKey && re.test(e.key)) {
                clearTimeout(tm);
                tm = setTimeout(() => text = '', debouncePeriod);
                text += e.key.toLocaleLowerCase();
                text.length > 0 && on(text);
            }
        };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, deps);
};
